import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import project1 from "../images/html-css-javascript-lg.jpg";
import project2 from "../images/html-css-javascript.jpg";
import project3 from "../images/javascript-fullstack.jpg";
import project4 from "../images/mern-stack.jpg";
import project5 from "../images/react-redux.jpg";
import project6 from "../images/react.png";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "#233",
    height: "100%",
  },
  cardContainer: {
    maxWidth: 345,
    margin: "3rem auto",
  },
}));

const projects = [
  {
    name: "Schedule Management",
    description: `This is project is schedule management web app. This
    web app is built with React framework. Especially, all data is managed by React-Redux,
    React-Saga, Context or something. Moreover, for login and signup, JWT is used by server.`,
    image: project1,
  },
  {
    name: "Cosmetics",
    description: `This project is cosmetics theme based on wordpress. The core technology \ 
    of this project is wordpres. Especially, variety action and hook. Child-theme \ 
    is very effective. Project is being favored by a large number of users now.`,
    image: project2,
  },
  {
    name: "Web Design",
    description: `This is only Html design using only Html and CSS\
    Here, the main is to make use of Sass and Html5. User-friendly, Dom Optimizatio is focused.\
    Dom structure is essential for Web design.\
    All tags isn't used repeatly.`,
    image: project3,
  },
  {
    name: "Fruit Milk Purchase",
    description: `This is for selling variety fruit milk. As soon as this is launched,\
    many customer is being used without no problem.\
    It's because this is built based on MERN stack technology.\
    Nowadays, MERN is very popular technology.`,
    image: project4,
  },
  {
    name: "Meeting Schedule",
    description: `This is developed by React and Django.\
    The object of this site is to manage meeting schedule effectively and notify to people related to meeting automatically at timely.\
    Node notification module and Django API package is used.`,
    image: project5,
  },
  {
    name: "Online Test",
    description: `This project provide online test environment for student.\
    This proejct is built with React and Laravel so that many students has exam simultaneously.\
    After exam is finised, result is generated and is dispatched to user's email.!`,
    image: project6,
  },
];

const Portfolio = () => {
  const classes = useStyles();
  return (
    <Box component="div" className={classes.mainContainer}>
      <Grid container justify="center">
        {/* Projects */}
        {projects.map((project, i) => (
          <Grid item xs={12} sm={8} md={4} key={i}>
            <Card className={classes.cardContainer}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  alt="Project 1"
                  height="140"
                  image={project.image}
                />
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {project.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {project.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button size="small" color="primary"></Button>
                <Button size="small" color="primary"></Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Portfolio;
